import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const itemId = (to) => to.replace(/[/#]/g, '-').replace(/^-/, '');

export const MegaMenuPanel = ({ group, onClose }) => (
  <div className="hv-mega absolute left-0 right-0 top-full pt-2 z-50" data-testid={`${group.testId}-menu`} role="region" aria-label={`${group.label} Menü`}>
    <div className="bg-[#FFFEFA] border border-[#DEDFD3] rounded-[6px] shadow-[0_32px_64px_-24px_rgba(21,59,43,0.45)] overflow-hidden">
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-3 bg-[#F4F1E8] p-8 border-r border-[#DEDFD3]">
          <p className="hv-kicker text-xs font-semibold uppercase tracking-[0.18em] text-[#647064] mb-4">{group.intro.kicker}</p>
          <p className="hv-serif text-[24px] leading-[1.15] text-[#19392B] mb-4">{group.intro.title}</p>
          <p className="text-sm text-[#647064] leading-relaxed">{group.intro.text}</p>
        </div>
        <div className="lg:col-span-6 p-8 grid sm:grid-cols-2 gap-8">
          {group.columns.map((col) => (
            <div key={col.title}>
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#647064] mb-3">{col.title}</p>
              <ul className="space-y-1">
                {col.items.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} onClick={onClose} data-testid={`nav-item-${itemId(item.to)}`} className="hv-nav-item hv-mega-item group flex items-start gap-3 px-3 py-2.5 rounded-[4px]">
                      {item.icon && <item.icon className="w-[18px] h-[18px] text-[#1C432F] shrink-0 mt-0.5" aria-hidden="true" />}
                      <span>
                        <span className="block text-[15px] font-medium text-[#19392B] group-hover:text-[#1C432F]">{item.label}</span>
                        {item.hint && <span className="block text-[13px] text-[#647064] mt-0.5">{item.hint}</span>}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Link to={group.feature.to} onClick={onClose} data-testid={`${group.testId}-feature`} className="hv-mega-feature lg:col-span-3 relative min-h-[260px] block overflow-hidden group">
          <img src={group.feature.image} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
          <span className="hv-tile-fade absolute inset-0" aria-hidden="true" />
          <span className="absolute inset-x-0 bottom-0 p-7 text-[#F8F6F0]">
            <span className="block text-xs font-semibold uppercase tracking-[0.16em] text-[#DFC590] mb-2">{group.feature.label}</span>
            <span className="hv-serif block text-[24px] leading-[1.15] mb-2">{group.feature.title}</span>
            <span className="block text-sm text-[#DDE4DC] mb-4">{group.feature.text}</span>
            <span className="inline-flex items-center gap-2 text-sm font-semibold">Mehr erfahren <ArrowRight className="w-4 h-4" aria-hidden="true" /></span>
          </span>
        </Link>
      </div>
    </div>
  </div>
);

export const megaItems = (group) => (group.mega ? group.columns.flatMap((c) => c.items) : group.items);
